import React, { useEffect, useState } from "react"
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  Table,
  TabPane,
  UncontrolledTooltip,
} from "reactstrap"
import Breadcrumb from "components/Common/Breadcrumb"
import Logo from "../../assets/images/logo.png"
import {
  FaChevronLeft,
  FaChevronRight,
  FaPen,
  FaTrash,
  FaPlus,
  FaDownload,
  FaEye,
  FaBell,
  FaCheck,
  FaXmark,
} from "react-icons/fa6"
import moment from "moment"
import Select from "react-select"
import { customStyles } from "utils/SelectStyles"
import {
  fetchData,
  FetchDeleteData,
  FetchPostData,
  FetchPutData,
} from "utils/Common_api_functions"
import Swal from "sweetalert2"
import Loader from "components/Loader/loader"
import Configs from "../../config"

const LeagueIndex = () => {
  const [loading, setloading] = useState(false)

  const [searchString, setSearchString] = useState("")
  const [activeTab, setActiveTab] = useState("standings")
  const [leagues, setLeagues] = useState([])
  const [selectedLeague, setselectedLeague] = useState({})
  const [data, setData] = useState([])
  const [clubData, setClubData] = useState([])
  const [seasonData, setSeasonData] = useState([])
  const [requests, setRequests] = useState([])
  const [page, setPage] = useState(1)
  const [itemsPerPage] = useState(10)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [editingLeague, setEditingLeague] = useState(null)
  const [formData, setFormData] = useState({
    leagueName: "",
    season: "",
    startDate: "",
    endDate: "",
    clubs: [],
  })

  const [leagueUserModal, setLeagueUserModal] = useState(false)
  const [selectedClub, setSelectedClub] = useState({})
  const [selectedInvites, setSelectedInvites] = useState([])
  const [invitePage, setInvitePage] = useState(1)
  const inviteItemsPerPage = 10

  useEffect(() => {
    getData()
    getDropdownData()
  }, [])

  useEffect(() => {
    const fetchClubs = async () => {
      console.log(formData?.startDate, formData?.endDate)
      if (formData?.startDate && formData?.endDate) {
        const APIData = await FetchPostData(setloading, "club/with/filter", {
          startDate: formData?.startDate,
          endDate: formData?.endDate,
          leagueId: editingLeague?._id,
        })

        if (APIData?.data?.success) {
          const clubOptions = APIData?.data?.data?.map(item => ({
            value: item._id,
            label: item.clubName,
          }))
          setClubData(clubOptions)
        }
      }
    }

    fetchClubs()
  }, [formData?.startDate, formData?.endDate])

  async function getData() {
    const APIData = await fetchData(setloading, "league")
    if (APIData?.success) {
      setLeagues(APIData?.leagues)
      setData(APIData?.leagues)
    }
  }

  useEffect(() => {
    if (searchString !== "") {
      const filteredData = data.filter(item =>
        item.leagueName.toLowerCase().includes(searchString.toLowerCase())
      )
      setLeagues(filteredData)
      setPage(1)
    } else {
      setLeagues(data)
    }
  }, [searchString, data])

  async function getDropdownData() {
    const APIData = await fetchData(setloading, "season")
    const APIData2 = await fetchData(setloading, "club")

    const seasonOptions =
      APIData?.seasons?.map(item => ({
        value: item._id,
        label: `${item.seasonName} (${moment(item?.startDate).format(
          "DD-MM-YYYY"
        )} - ${moment(item?.endDate).format("DD-MM-YYYY")})`,
      })) || []

    setSeasonData(seasonOptions)
  }

  const [viewLeague, setViewLeague] = useState(null)
  const [inviteClubFilter, setInviteClubFilter] = useState("")
  const [inviteStatusFilter, setInviteStatusFilter] = useState("")
  const [inviteNameSearch, setInviteNameSearch] = useState("")
  const totalPages = Math.ceil(leagues.length / itemsPerPage)
  const finalData = leagues.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  )

  const changePage = pageNumber => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setPage(pageNumber)
      window.scrollTo(0, 0)
    }
  }

  const handleInputChange = e => {
    const { name, value } = e.target
    setFormData({ ...formData, [name]: value })
  }

  const handleAddLeague = () => {
    setEditingLeague(null)
    setFormData({
      leagueName: "",
      season: "",
      startDate: "",
      endDate: "",
      clubs: [],
    })
    setIsModalOpen(true)
  }

  const handleEditLeague = league => {
    setEditingLeague(league)
    setFormData({
      leagueName: league?.leagueName,
      season: league?.season?._id,
      startDate: league?.startDate,
      endDate: league?.endDate,
      clubs: league?.clubs?.map(c => c._id),
    })
    setIsModalOpen(true)
  }

  const handleDeleteLeague = id => {
    Swal.fire({
      title: "Are you sure?",
      text: "This action will permanently delete the League.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async result => {
      if (result.isConfirmed) {
        const APIData = await FetchDeleteData(setloading, "league", id)

        if (APIData?.data?.success) {
          Swal.fire({
            title: "League Deleted Successfully",
            icon: "success",
          })
          getData()
        } else {
          Swal.fire({
            title: "Something Went Wrong",
            text: APIData?.response?.data?.message,
            icon: "error",
          })
        }
      }
    })
  }

  const handleSubmit = async e => {
    e.preventDefault()
    if (editingLeague) {
      const APIData = await FetchPutData(
        setloading,
        "league",
        editingLeague._id,
        formData
      )

      if (APIData?.data?.success) {
        Swal.fire({
          icon: "success",
          title: "League Updated Successfully",
        })
      } else {
        Swal.fire({
          icon: "error",
          title: "Something went wrong",
        })
      }
      getData()
    } else {
      const APIData = await FetchPostData(setloading, "league", formData)

      if (APIData?.data?.success) {
        Swal.fire({
          icon: "success",
          title: "League Added Successfully",
        })
      } else {
        Swal.fire({
          icon: "error",
          title: "Something went wrong",
        })
      }
      getData()
    }
    setIsModalOpen(false)
  }

  // const handleExport = async league => {
  //   const APIdata = await fetchData(setloading, `league/export/${league._id}`)

  //   if (APIdata?.data) {
  //     // 2️⃣ Expect CSV or JSON
  //     if (!response.ok) throw new Error("Failed to export CSV")

  //     const blob = await response.blob()
  //     const url = window.URL.createObjectURL(blob)

  //     // 3️⃣ Trigger download
  //     const link = document.createElement("a")
  //     link.href = url
  //     link.download = `${league.leagueName || "league"}-export.csv`
  //     document.body.appendChild(link)
  //     link.click()
  //     link.remove()

  //     window.URL.revokeObjectURL(url)
  //   } else {
  //     Swal.fire({
  //       title: "Something Went Wrong",
  //       text: APIdata?.response?.data?.message,
  //       icon: "error",
  //     })
  //   }
  // }

  const handleExport = league => {
    // Construct the full API URL
    const url = `${Configs.baseURL}league/export/${league._id}`

    // Open in a new tab
    window.open(url, "_blank")
  }

  const handleLeagueView = async leagueId => {
    setInviteClubFilter("")
    setInviteStatusFilter("")

    const APIdata = await fetchData(
      setloading,
      `league/leaderboard/${leagueId}`
    )

    if (APIdata?.success) {
      setselectedLeague(APIdata)
      setViewLeague(true)
    }

    const APIdata1 = await fetchData(
      setloading,
      `league/join/requests/${leagueId}`
    )

    if (APIdata1?.success) {
      setRequests(APIdata1?.data)
    }
  }

  const toggleInviteSelect = id => {
    setSelectedInvites(prev =>
      prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]
    )
  }

  const handleUpdateInviteStatus = async (requestId, status) => {
    const APIData = await FetchPutData(
      setloading,
      "league/join/requests/status",
      requestId,
      { acceptanceStatus: status }
    )
    if (APIData?.data?.success) {
      Swal.fire({
        icon: "success",
        title: status ? "Invite Accepted" : "Invite Rejected",
      })

      handleLeagueView(selectedLeague?.leagueId)
    } else {
      Swal.fire({
        icon: "error",
        title: "Something went wrong",
        text: APIData?.response?.data?.message,
      })
    }
  }

  const handleNotifyInvites = async ids => {
    const isSingle = ids.length === 1
    const payload = {
      leagueId: selectedLeague?._id,
      ...(isSingle ? { userId: ids[0] } : { userIds: ids }),
    }
    const APIData = await FetchPostData(
      setloading,
      "league/join/requests/notify",
      payload
    )
    if (APIData?.data?.success) {
      Swal.fire({ icon: "success", title: "Notification Sent Successfully" })
      setSelectedInvites([])
    } else {
      Swal.fire({
        icon: "error",
        title: "Something went wrong",
        text: APIData?.response?.data?.message,
      })
    }
  }

  const handleResetInvite = async id => {
    const payload = { leagueId: selectedLeague?._id, userId: id }
    const APIData = await FetchPostData(
      setloading,
      "league/join/requests/reset",
      payload
    )
    if (APIData?.data?.success) {
      Swal.fire({ icon: "success", title: "Invite Reset Successfully" })
      handleLeagueView(selectedLeague?._id)
    } else {
      Swal.fire({
        icon: "error",
        title: "Something went wrong",
        text: APIData?.response?.data?.message,
      })
    }
  }

  const inviteClubOptions = [
    ...new Map(
      requests
        ?.filter(r => r?.user?.club?.clubName)
        ?.map(r => [
          r.user.club._id,
          { value: r.user.club._id, label: r.user.club.clubName },
        ])
    ).values(),
  ]

  const filteredRequests = requests?.filter(item => {
    const clubMatch = inviteClubFilter
      ? item?.user?.club?._id === inviteClubFilter
      : true
    const statusMatch =
      inviteStatusFilter === ""
        ? true
        : inviteStatusFilter === "accepted"
        ? item?.acceptanceStatus === true
        : inviteStatusFilter === "rejected"
        ? item?.acceptanceStatus === false
        : item?.acceptanceStatus == null
    const nameMatch = inviteNameSearch
      ? item?.user?.name?.toLowerCase().includes(inviteNameSearch.toLowerCase())
      : true

    return clubMatch && statusMatch && nameMatch
  })

  const inviteTotalPages = Math.ceil(
    (filteredRequests?.length || 0) / inviteItemsPerPage
  )
  const paginatedRequests = filteredRequests?.slice(
    (invitePage - 1) * inviteItemsPerPage,
    invitePage * inviteItemsPerPage
  )

  const changeInvitePage = pageNumber => {
    if (pageNumber > 0 && pageNumber <= inviteTotalPages) {
      setInvitePage(pageNumber)
    }
  }

  const notAcceptedByClub = requests?.reduce((acc, item) => {
    if (item?.acceptanceStatus !== true) {
      const clubId = item?.user?.club?._id
      if (clubId) acc[clubId] = (acc[clubId] || 0) + 1
    }
    return acc
  }, {})

  return (
    <div className="page-content">
      {loading && <Loader />}
      <Container fluid>
        <Breadcrumb title="" breadcrumbItem="League Management" />

        <Row>
          <Col lg="12">
            <Card>
              <CardBody>
                <div className="d-flex justify-content-between align-items-center">
                  <h4 className="text-black fw-bold ps-1 mb-0">Leagues</h4>
                  <div className="d-flex gap-3">
                    <div className="form-group">
                      <Input
                        placeholder="Search Leagues"
                        value={searchString}
                        onChange={e => setSearchString(e.target.value)}
                      />
                    </div>
                    {/* <div style={{ minWidth: "200px" }}>
                      <Select
                        options={activityOptions}
                        value={activityOptions.find(
                          opt => opt.value === selectedActivity
                        )}
                        onChange={opt => setSelectedActivity(opt?.value || "")}
                        placeholder="Filter by Activity"
                        isClearable
                        styles={customStyles}
                      />
                    </div> */}
                    <Button className="btn btn-add" onClick={handleAddLeague}>
                      <FaPlus className="me-1" /> Add League
                    </Button>
                  </div>
                </div>

                <div className="mt-3">
                  <Table responsive bordered className="rounded-3">
                    <thead className="table-primary text-dark">
                      <tr>
                        <th>Sr No.</th>
                        <th>League Name</th>
                        <th>Season</th>
                        <th>Start Date</th>
                        <th>End Date</th>
                        <th>Clubs</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {finalData.map((league, index) => {
                        return (
                          <tr key={league.id}>
                            <td>{(page - 1) * itemsPerPage + index + 1}</td>
                            <td>{league.leagueName}</td>
                            <td>{league?.season?.seasonName || "N/A"}</td>
                            <td>
                              {moment(league.startDate).format("DD-MM-YYYY")}
                            </td>
                            <td>
                              {moment(league.endDate).format("DD-MM-YYYY")}
                            </td>
                            <td style={{ maxWidth: "270px" }}>
                              {league.clubs.map(c => c.clubName).join(", ")}
                            </td>
                            <td>
                              <button
                                className="btn btn-sm btn-outline-primary me-2"
                                onClick={() => handleExport(league)}
                              >
                                <FaDownload size={12} />
                              </button>
                              <button
                                className="btn btn-sm btn-outline-primary me-2"
                                onClick={() => {
                                  handleLeagueView(league?._id)
                                }}
                              >
                                <FaEye size={12} />
                              </button>
                              <button
                                className="btn btn-sm btn-outline-secondary me-2"
                                onClick={() => handleEditLeague(league)}
                              >
                                <FaPen size={12} />
                              </button>
                              <button
                                className="btn btn-sm btn-outline-danger"
                                onClick={() => handleDeleteLeague(league._id)}
                              >
                                <FaTrash size={12} />
                              </button>
                            </td>
                          </tr>
                        )
                      })}
                      {finalData.length === 0 && (
                        <tr>
                          <td colSpan={7} className="text-center">
                            No Data Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>

                <div className="d-flex justify-content-between align-items-center my-2 px-2">
                  <p className="mb-0">
                    Showing {finalData.length} out of {leagues.length} Leagues.
                  </p>
                  <div className="d-flex flex-wrap">
                    <div
                      className="bd-number-pagination me-1"
                      onClick={() => changePage(page - 1)}
                      style={{ cursor: "pointer" }}
                    >
                      <FaChevronLeft />
                    </div>
                    {[...Array(totalPages)].map((_, i) => {
                      const pageIndex = i + 1
                      return (
                        <div
                          key={pageIndex}
                          className={`bd-number-pagination me-1 ${
                            page === pageIndex ? "activepage" : ""
                          }`}
                          onClick={() => changePage(pageIndex)}
                          style={{ cursor: "pointer" }}
                        >
                          {pageIndex < 10 ? "0" + pageIndex : pageIndex}
                        </div>
                      )
                    })}
                    <div
                      className="bd-number-pagination"
                      onClick={() => changePage(page + 1)}
                      style={{ cursor: "pointer" }}
                    >
                      <FaChevronRight />
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* Add/Edit Modal */}
      <Modal
        isOpen={isModalOpen}
        toggle={() => setIsModalOpen(!isModalOpen)}
        centered
        size="lg"
      >
        <ModalHeader toggle={() => setIsModalOpen(!isModalOpen)}>
          {editingLeague ? "Edit League" : "Add League"}
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={handleSubmit}>
            <FormGroup>
              <Label>
                League Name <span className="text-danger">*</span>
              </Label>
              <Input
                type="text"
                name="leagueName"
                value={formData.leagueName}
                onChange={handleInputChange}
                required
              />
            </FormGroup>
            <FormGroup>
              <Label>
                Season <span className="text-danger">*</span>
              </Label>
              <Input
                type="select"
                name="season"
                value={formData.season}
                onChange={handleInputChange}
                required
              >
                <option value="">-- Select Season --</option>
                {seasonData?.map(s => (
                  <option key={s.id} value={s.value}>
                    {s.label}
                  </option>
                ))}
              </Input>
            </FormGroup>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label>
                    Start Date <span className="text-danger">*</span>
                  </Label>
                  <Input
                    type="date"
                    name="startDate"
                    value={moment(formData.startDate).format("YYYY-MM-DD")}
                    onChange={handleInputChange}
                    required
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label>
                    End Date <span className="text-danger">*</span>
                  </Label>
                  <Input
                    type="date"
                    name="endDate"
                    value={moment(formData.endDate).format("YYYY-MM-DD")}
                    onChange={handleInputChange}
                    required
                    min={
                      formData?.startDate
                        ? moment(formData.startDate).format("YYYY-MM-DD")
                        : undefined
                    }
                  />
                </FormGroup>
              </Col>
            </Row>
            <FormGroup>
              <Label>Clubs</Label>
              <Select
                isMulti
                options={clubData}
                value={clubData.filter(opt =>
                  formData.clubs.includes(opt.value)
                )}
                onChange={opts =>
                  setFormData({
                    ...formData,
                    clubs: opts ? opts.map(o => o.value) : [],
                  })
                }
                placeholder="Select clubs..."
                styles={customStyles}
              />
            </FormGroup>

            <div className="text-end">
              <Button color="primary" type="submit">
                {editingLeague ? "Update" : "Add"}
              </Button>
              <Button
                color="danger"
                className="ms-2"
                onClick={() => setIsModalOpen(!isModalOpen)}
              >
                Cancel
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>

      {/* View Modal */}
      <Modal
        isOpen={!!viewLeague}
        toggle={() => setViewLeague(null)}
        centered
        size="xl"
      >
        <ModalHeader toggle={() => setViewLeague(null)}>
          League Standings - {selectedLeague?.leagueName}
        </ModalHeader>
        <ModalBody>
          <Nav tabs className="mb-3">
            <NavItem>
              <NavLink
                className={
                  activeTab === "standings" ? "active fw-semibold" : ""
                }
                style={{ cursor: "pointer" }}
                onClick={() => setActiveTab("standings")}
              >
                Standings
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={activeTab === "signedUp" ? "active fw-semibold" : ""}
                style={{ cursor: "pointer" }}
                onClick={() => setActiveTab("signedUp")}
              >
                Signed Up
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={activeTab === "invites" ? "active fw-semibold" : ""}
                style={{ cursor: "pointer" }}
                onClick={() => setActiveTab("invites")}
              >
                Invites
              </NavLink>
            </NavItem>
          </Nav>

          <TabContent activeTab={activeTab}>
            {/* Standings Tab */}
            <TabPane tabId="standings">
              <Table responsive bordered className="rounded-3">
                <thead className="table-dark text-white">
                  <tr>
                    <th>Position</th>
                    <th>Team</th>
                    <th>Fans</th>
                    <th>Activities</th>
                    <th>Distance</th>
                    <th>Points</th>
                    <th>parkrun points</th>
                    <th>Average Points</th>
                    <th>Total Points</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedLeague?.data?.map((row, index) => (
                    <tr
                      key={row.id}
                      onClick={() => {
                        setSelectedClub(row), setLeagueUserModal(true)
                      }}
                    >
                      <td>{index + 1}</td>
                      <td>
                        <img
                          src={`${Configs?.imageurl}${row?.clubImage}`}
                          alt={row.team}
                          style={{ width: "30px", marginRight: "8px" }}
                        />
                        {row.clubName}
                      </td>
                      <td>{row.eligibleUsers.length}</td>
                      <td>{row.totalActivities}</td>
                      <td>{row.totalDistanceCovered}</td>
                      <td className="fw-bold">{row.points}</td>
                      <td className="fw-bold">{row.parkRunPoints}</td>
                      <td className="fw-bold">
                        {(row.totalPoints / row.users).toFixed(2) || 0}
                      </td>
                      <td className="fw-bold">{row.totalPoints}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </TabPane>

            {/* Invites Tab */}
            <TabPane tabId="invites">
              <div className="d-flex gap-3 mb-3">
                <div style={{ minWidth: "200px" }}>
                  <Select
                    options={inviteClubOptions}
                    value={
                      inviteClubOptions.find(
                        o => o.value === inviteClubFilter
                      ) || null
                    }
                    onChange={opt => {
                      setInviteClubFilter(opt?.value || "")
                      setInvitePage(1)
                    }}
                    placeholder="Filter by Club"
                    isClearable
                    styles={customStyles}
                  />
                </div>
                <div style={{ minWidth: "200px" }}>
                  <Select
                    options={[
                      { value: "accepted", label: "Accepted" },
                      { value: "rejected", label: "Rejected" },
                      { value: "pending", label: "Pending" },
                    ]}
                    value={
                      inviteStatusFilter
                        ? {
                            value: inviteStatusFilter,
                            label:
                              inviteStatusFilter.charAt(0).toUpperCase() +
                              inviteStatusFilter.slice(1),
                          }
                        : null
                    }
                    onChange={opt => {
                      setInviteStatusFilter(opt?.value || "")
                      setInvitePage(1)
                    }}
                    placeholder="Filter by Status"
                    isClearable
                    styles={customStyles}
                  />
                </div>
                <div style={{ minWidth: "200px" }}>
                  <Input
                    type="text"
                    placeholder="Search by Name"
                    value={inviteNameSearch}
                    onChange={e => {
                      setInviteNameSearch(e.target.value)
                      setInvitePage(1)
                    }}
                  />
                </div>
              </div>
              {selectedInvites.length > 0 && (
                <div className="d-flex justify-content-end gap-2 mb-2">
                  <Button
                    color="warning"
                    onClick={() => handleNotifyInvites(selectedInvites)}
                  >
                    Notify Selected ({selectedInvites.length})
                  </Button>
                </div>
              )}
              <Table responsive bordered className="rounded-3">
                <thead className="table-dark text-white">
                  <tr>
                    <th style={{ width: "40px" }}></th>
                    <th>Club</th>
                    <th>Athlete Name</th>
                    <th>Invite</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedRequests?.map(item => (
                    <tr key={item?._id}>
                      <td>
                        {item?.acceptanceStatus !== true && (
                          <input
                            type="checkbox"
                            checked={selectedInvites.includes(item?._id)}
                            onChange={() => toggleInviteSelect(item?._id)}
                          />
                        )}
                      </td>
                      <td>{item?.user?.club?.clubName}</td>
                      <td>{item?.user?.name}</td>
                      <td>
                        <div className="d-flex align-items-center gap-2">
                          {item?.acceptanceStatus === true ? (
                            <span className="badge rounded-pill fs-6 p-2 bg-success">
                              Accepted
                            </span>
                          ) : item?.acceptanceStatus === false ? (
                            <span className="badge rounded-pill fs-6 p-2 bg-danger">
                              Rejected
                            </span>
                          ) : (
                            <span className="badge rounded-pill fs-6 p-2 bg-warning text-dark">
                              Pending
                            </span>
                          )}
                          {item?.acceptanceStatus == null && (
                            <FaBell
                              title="Send Notification"
                              style={{
                                cursor: "pointer",
                                color: "#f39c12",
                                fontSize: "1.1rem",
                              }}
                              onClick={() => handleNotifyInvites([item?._id])}
                            />
                          )}
                          {item?.acceptanceStatus === false && (
                            <FaBell
                              title="Reset Invite"
                              style={{
                                cursor: "pointer",
                                color: "#e74c3c",
                                fontSize: "1.1rem",
                              }}
                              onClick={() => handleResetInvite(item?._id)}
                            />
                          )}
                        </div>
                      </td>
                      <td>
                        <div className="d-flex align-items-center gap-2">
                          {item?.acceptanceStatus !== true && (
                            <FaCheck
                              title="Accept"
                              style={{
                                cursor: "pointer",
                                color: "#27ae60",
                                fontSize: "1.1rem",
                              }}
                              onClick={() =>
                                handleUpdateInviteStatus(item?._id, true)
                              }
                            />
                          )}
                          {item?.acceptanceStatus !== false && (
                            <FaXmark
                              title="Reject"
                              style={{
                                cursor: "pointer",
                                color: "#e74c3c",
                                fontSize: "1.1rem",
                              }}
                              onClick={() =>
                                handleUpdateInviteStatus(item?._id, false)
                              }
                            />
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              {inviteTotalPages > 1 && (
                <div className="d-flex justify-content-between align-items-center my-2 px-2">
                  <p className="mb-0">
                    Showing {(invitePage - 1) * inviteItemsPerPage + 1}–
                    {Math.min(
                      invitePage * inviteItemsPerPage,
                      filteredRequests?.length || 0
                    )}{" "}
                    of {filteredRequests?.length || 0} invites
                  </p>
                  <div className="d-flex flex-wrap">
                    <div
                      className="bd-number-pagination me-1"
                      onClick={() => changeInvitePage(invitePage - 1)}
                      style={{ cursor: "pointer" }}
                    >
                      <FaChevronLeft />
                    </div>
                    {(() => {
                      const half = 2
                      let start = Math.max(1, invitePage - half)
                      let end = Math.min(inviteTotalPages, start + 4)
                      if (end - start < 4) start = Math.max(1, end - 4)
                      return Array.from(
                        { length: end - start + 1 },
                        (_, i) => start + i
                      ).map(pageIndex => (
                        <div
                          key={pageIndex}
                          className={`bd-number-pagination me-1 ${
                            invitePage === pageIndex ? "activepage" : ""
                          }`}
                          onClick={() => changeInvitePage(pageIndex)}
                          style={{ cursor: "pointer" }}
                        >
                          {pageIndex < 10 ? "0" + pageIndex : pageIndex}
                        </div>
                      ))
                    })()}
                    <div
                      className="bd-number-pagination"
                      onClick={() => changeInvitePage(invitePage + 1)}
                      style={{ cursor: "pointer" }}
                    >
                      <FaChevronRight />
                    </div>
                  </div>
                </div>
              )}
            </TabPane>
            {/* Not Accepted Tab */}
            <TabPane tabId="signedUp">
              <Table responsive bordered className="rounded-3">
                <thead className="table-dark text-white">
                  <tr>
                    <th>#</th>
                    <th>Club</th>
                    <th>
                      Total Users{" "}
                      <span
                        id="tooltip-total-users"
                        style={{ cursor: "pointer", fontSize: "0.8rem" }}
                      >
                        &#9432;
                      </span>
                      <UncontrolledTooltip target="tooltip-total-users">
                        Total number of users in the club who have signed up for
                        the league.
                      </UncontrolledTooltip>
                    </th>
                    <th>
                      Not Connected to Strava{" "}
                      <span
                        id="tooltip-not-strava"
                        style={{ cursor: "pointer", fontSize: "0.8rem" }}
                      >
                        &#9432;
                      </span>
                      <UncontrolledTooltip target="tooltip-not-strava">
                        Shows Total Users / Users who have not connected their
                        Strava account.
                      </UncontrolledTooltip>
                    </th>
                    <th>
                      No Activity Recorded{" "}
                      <span
                        id="tooltip-no-activity"
                        style={{ cursor: "pointer", fontSize: "0.8rem" }}
                      >
                        &#9432;
                      </span>
                      <UncontrolledTooltip target="tooltip-no-activity">
                        Users who have not recorded any activity since joining
                        the league.
                      </UncontrolledTooltip>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {selectedLeague?.data?.map((row, index) => (
                    <tr key={row._id || row.clubId}>
                      <td>{index + 1}</td>

                      <td>
                        <img
                          src={`${Configs?.imageurl}${row?.clubImage}`}
                          // alt={row.clubName}
                          style={{ width: "30px", marginRight: "8px" }}
                        />
                        {row.clubName}
                      </td>

                      {/* 👇 Eligible Users */}
                      <td>{row?.users}</td>

                      <td>
                        {row.eligibleUsers?.length > 0 ? (
                          <div>
                            {`${row?.users} / ${
                              row?.eligibleUsers?.filter(
                                item => !item?.isStravaConnected
                              ).length
                            }`}
                          </div>
                        ) : (
                          <span>No eligible users</span>
                        )}
                      </td>

                      <td>
                        {row.eligibleUsers?.length > 0 ? (
                          <div>
                            {
                              row?.eligibleUsers?.filter(
                                item =>
                                  item?.isStravaConnected &&
                                  item?.totalPoints === 0
                              ).length
                            }
                          </div>
                        ) : (
                          <span>No eligible users</span>
                        )}
                      </td>
                      <td></td>
                    </tr>
                  ))}

                  {selectedLeague?.data?.every(
                    row => (notAcceptedByClub[row._id || row.clubId] || 0) === 0
                  ) && (
                    <tr>
                      <td colSpan={4} className="text-center">
                        All users have accepted
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </TabPane>
          </TabContent>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={leagueUserModal}
        size="lg"
        centered
        toggle={() => setLeagueUserModal(false)}
      >
        <ModalHeader toggle={() => setLeagueUserModal(false)}>
          League : {selectedLeague?.leagueName} | Club :{" "}
          {selectedClub?.clubName}
        </ModalHeader>
        <ModalBody>
          <Table>
            <thead className="table-dark text-white">
              <tr>
                <th>#</th>
                <th>Athlete</th>
                <th>Activity</th>
                <th>Points</th>
                <th>Parkrun Points</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {selectedClub?.eligibleUsers?.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item?.name}</td>
                  <td>{item?.activities}</td>
                  <td>{item?.points}</td>
                  <td>{item?.parkRunPoints}</td>
                  <td>{item?.totalPoints}</td>
                </tr>
              ))}
              <tr></tr>
            </tbody>
          </Table>
        </ModalBody>
      </Modal>
    </div>
  )
}

export default LeagueIndex
